import { render, staticRenderFns } from "./orderMGTGroup.vue?vue&type=template&id=fa9ccb5e&scoped=true&"
import script from "./orderMGTGroup.vue?vue&type=script&lang=js&"
export * from "./orderMGTGroup.vue?vue&type=script&lang=js&"
import style0 from "./orderMGTGroup.vue?vue&type=style&index=0&id=fa9ccb5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9ccb5e",
  null
  
)

export default component.exports